import { Select } from '@faceup/ui-base'
import { convertRegionToRegionName, SupportedRegion } from '@faceup/utils'
import { DEFAULT_SUPPORTED_REGION, useRegion } from '../utils/useRegion'

const regionSelectId = 'administration-region'

const regionOptions = Object.values(SupportedRegion).map(region => ({
  label: convertRegionToRegionName(region),
  value: region,
}))

export const RegionHeader = () => {
  const { region, setRegion } = useRegion()

  return (
    <div className='sticky top-0 z-1 flex justify-end bg-colorBgLayout p-3'>
      <label htmlFor={regionSelectId} className='sr-only'>
        Administration region
      </label>
      <Select
        id={regionSelectId}
        className='w-64'
        value={region ?? DEFAULT_SUPPORTED_REGION}
        onSelect={setRegion}
        options={regionOptions}
      />
    </div>
  )
}
